// MembershipPayment.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

// Containers
import MainStructure from '../components/containers/MainStructure';
import MembershipPlans from '../components/MembershipPayment/MembershipPlans';
import RedirectToCheckout from '../components/MembershipPayment/RedirectToCheckout';
import { authenticationService } from '../api/authentication.service';
import { userService } from '../api/user.service';

function MembershipPayment() {
  const [step, setStep] = useState(1);
  const [flowData, setFlowData] = useState({});

  useEffect(() => {
    userService
      .details()
      .then((updatedUser) => {
        authenticationService.updateUserDetails(updatedUser);
      })
      .catch((error) => {
        console.error('Error refreshing user details', error);
      });
  }, []);

  function nextStep(body, nextStepValue) {
    setFlowData({ ...flowData, ...body });
    setStep(nextStepValue);
  }

  let content;
  if (step === 1) {
    content = <MembershipPlans onUpdate={nextStep} />;
  } else if (step === 2) {
    content = <RedirectToCheckout planData={flowData} />;
  } else if (step === 3) {
    return <Navigate to="/" />;
  }

  return <MainStructure>{content}</MainStructure>;
}

export default MembershipPayment;
